import React, { useState } from 'react';
import { HelpCircle, X, ChevronLeft, ChevronRight } from 'lucide-react';

const TourGuide = ({ steps, tourKey, onComplete }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const safeSteps = Array.isArray(steps) ? steps : [];

  const openTour = () => {
    setCurrentStep(0);
    setIsOpen(true);
  };

  const closeTour = () => {
    setIsOpen(false);
    localStorage.setItem(`tour_${tourKey}_completed`, 'true');
    if (onComplete) onComplete();
  };

  const next = () => {
    if (currentStep < safeSteps.length - 1) {
      setCurrentStep(s => s + 1);
    } else {
      closeTour();
    }
  };

  const prev = () => {
    if (currentStep > 0) setCurrentStep(s => s - 1);
  };

  const step = safeSteps[currentStep];
  const isLast = currentStep === safeSteps.length - 1;

  return (
    <>
      {/* Fixed Tour Button */}
      <button
        onClick={openTour}
        title="Start Tour Guide"
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          zIndex: 9998,
          backgroundColor: '#ef4444',
          color: 'white',
          padding: '14px 22px',
          borderRadius: '50px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '15px',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
        }}
      >
        <HelpCircle size={20} />
        TOUR
      </button>

      {/* Modal Overlay */}
      {isOpen && step && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            backgroundColor: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
          onClick={(e) => { if (e.target === e.currentTarget) closeTour(); }}
        >
          <div
            style={{
              backgroundColor: 'var(--card-bg, #1e293b)',
              color: 'var(--text-primary, #f8fafc)',
              borderRadius: '16px',
              padding: '32px',
              maxWidth: '480px',
              width: '100%',
              boxShadow: '0 24px 64px rgba(0,0,0,0.5)',
              border: '1px solid rgba(255,255,255,0.1)',
              position: 'relative',
            }}
          >
            {/* Close */}
            <button
              onClick={closeTour}
              style={{
                position: 'absolute', top: '16px', right: '16px',
                background: 'transparent', border: 'none',
                color: 'var(--text-secondary, #94a3b8)',
                cursor: 'pointer', padding: '4px',
              }}
            >
              <X size={20} />
            </button>

            {/* Step counter */}
            <div style={{ fontSize: '12px', color: '#3b82f6', fontWeight: '700', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Step {currentStep + 1} of {safeSteps.length}
            </div>

            {/* Progress bar */}
            <div style={{ width: '100%', height: '4px', backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: '2px', marginBottom: '20px' }}>
              <div style={{
                height: '100%',
                width: `${((currentStep + 1) / safeSteps.length) * 100}%`,
                backgroundColor: '#3b82f6',
                borderRadius: '2px',
                transition: 'width 0.3s ease',
              }} />
            </div>

            {/* Title */}
            {step.title && (
              <h3 style={{ fontSize: '20px', fontWeight: '700', marginBottom: '12px', color: 'var(--text-primary, #f8fafc)' }}>
                {step.title}
              </h3>
            )}

            {/* Content */}
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: 'var(--text-secondary, #cbd5e1)', marginBottom: '28px' }}>
              {step.content}
            </p>

            {/* Navigation */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <button
                onClick={prev}
                disabled={currentStep === 0}
                style={{
                  display: 'flex', alignItems: 'center', gap: '6px',
                  background: 'transparent', border: '1px solid rgba(255,255,255,0.15)',
                  color: currentStep === 0 ? 'rgba(255,255,255,0.2)' : 'var(--text-secondary, #cbd5e1)',
                  cursor: currentStep === 0 ? 'not-allowed' : 'pointer',
                  padding: '10px 18px', borderRadius: '8px', fontSize: '14px', fontWeight: '500',
                }}
              >
                <ChevronLeft size={16} /> Back
              </button>

              <button
                onClick={closeTour}
                style={{
                  background: 'transparent', border: 'none',
                  color: 'rgba(255,255,255,0.35)',
                  cursor: 'pointer', fontSize: '13px',
                }}
              >
                Skip tour
              </button>

              <button
                onClick={next}
                style={{
                  display: 'flex', alignItems: 'center', gap: '6px',
                  backgroundColor: '#3b82f6', border: 'none',
                  color: 'white', cursor: 'pointer',
                  padding: '10px 20px', borderRadius: '8px', fontSize: '14px', fontWeight: '600',
                }}
              >
                {isLast ? 'Finish' : 'Next'} {!isLast && <ChevronRight size={16} />}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TourGuide;
